import Vue from 'vue'
import VueRouter from 'vue-router'
import Start from '@/views/dashboard/Start'
import InstallAuth from '@/views/dashboard/InstallAuth'
import Dashboard from '@/views/dashboard/Index'
import User from '@/views/user/User'
import BindMobile from '@/views/user/BindMobile'
import Withdraw from '@/views/user/Withdraw'
import Apprentice from '@/views/apprentice/Index'
import Commission from '@/views/commission/Index'
import TaskDetail from '@/views/task/Index'
import BindWechat from '@/views/user/BindWechat'
import Alipaybinding from '@/views/user/Alipaybinding'
import Alipaychange from '@/views/user/Alipaychange'
import Swichuser from '@/views/user/Swichuser'
import ShouTu from '@/views/marketing/shoutu/Welcome'
Vue.use(VueRouter)

export default new VueRouter({
  routes: [
    { path: '/', component: Start },
    { path: '/loading', component: Start },
    { path: '/installAuth/:totrust?', component: InstallAuth },
    { path: '/dashboard/:status?/:uuid?', component: Dashboard },
    { path: '/user', component: User },
    { path: '/bindMobile', component: BindMobile },
    { path: '/withdraw', component: Withdraw },
    { path: '/apprentice', component: Apprentice },
    { path: '/commission', component: Commission },
    { path: '/detail/:id', component: TaskDetail },
    { path: '/BindWechat', component: BindWechat },
    { path: '/alipaybinding', component: Alipaybinding },
    { path: '/alipaychange', component: Alipaychange },
    { path: '/swichuser', component: Swichuser },
    { path: '/outland/', component: ShouTu }
  ],
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  },
  mode: 'history',
  base: '/v1'
})
